import AbstractComponent from "./abstract-component";

const createTemplate = (className, count) => {
  return (
    `<button class="${className}__rating rating" type="button">
      <svg aria-hidden="true" width="24" height="24">
        <use href="sienge/img/sprite.svg#icon-star"></use>
      </svg>
      <span>${count}</span>
    </button>`
  );
};

export default class RatingComponent extends AbstractComponent {
  constructor({className = ``, count = 0}) {
    super();

    this._className = className;
    this._count = count;
  }

  getTemplate() {
    return createTemplate(this._className, this._count);
  }

  setClickHanlder(handler) {
    this.getElement().addEventListener(`click`, handler);
  }
}
